import BiospecimenDetails from './BiospecimenDetails';

export default BiospecimenDetails;
